<template>
    <div id="dicomQualityMenu" class="dropdown dropright dropdown-submenu border-bottom-item">
        <button class="dropdown-item" type="button">
            Dicom Quality
        </button>
        <div id="dicomQualitySubMenu" class="dropdown-menu secondary-menu">
            <label v-if="dicomLowLink" class="dropdown-item border-bottom-item dicom-on-item" for="cbDicomLow"
                @click.prevent.stop="dicomLowClick">
                <div class="form-check form-check-inline flex-menu-item">
                    <span class="form-check-label">Basic</span>
                    <div class="flex-separator"></div>
                    <input id="cbDicomLow" class="form-check-input" type="checkbox" v-model="isLowQuality"
                        @click.stop="dicomLowClick">
                </div>
            </label>
            <label v-if="dicomMiddleLink" class="dropdown-item border-bottom-item dicom-on-item" for="cbDicomMiddle"
                @click.prevent.stop="dicomMiddleClick">
                <div class="form-check form-check-inline flex-menu-item">
                    <span class="form-check-label">High</span>
                    <div class="flex-separator"></div>
                    <input id="cbDicomMiddle" class="form-check-input" type="checkbox" v-model="isMiddleQuality"
                        @click.stop="dicomMiddleClick">
                </div>
            </label>
            <label v-if="dicomHighLink" class="dropdown-item border-bottom-item dicom-on-item" for="cbDicomHigh"
                @click.prevent.stop="dicomHighClick">
                <div class="form-check form-check-inline flex-menu-item">
                    <span class="form-check-label">Original</span>
                    <div class="flex-separator"></div>
                    <input id="cbDicomHigh" class="form-check-input" type="checkbox" v-model="isHighQuality"
                        @click.stop="dicomHighClick">
                </div>
            </label>
        </div>
    </div>
</template>

<script>
import { mutationTypes } from '@/store/modules/dicom';
import {
    updateDicomZipUrl
} from "./DicomManager.js";

export default {
    name: "DicomQualityMenu",
    props: [
        "dicomLowLink",
        "dicomMiddleLink",
        "dicomHighLink"
    ],
    computed: {
        isLowQuality: {
            get: function () {
                return this.$store.state.dicom.isLowQuality;
            },
            set: function (value) {
                if (value && !this.$store.state.dicom.isLowQuality) {
                    this.$store.commit(mutationTypes.isLowQualityChange, true);
                    this.$store.commit(mutationTypes.isMiddleQualityChange, false);
                    this.$store.commit(mutationTypes.isHighQualityChange, false);
                    updateDicomZipUrl();
                }
            }
        },
        isMiddleQuality: {
            get: function () {
                return this.$store.state.dicom.isMiddleQuality;
            },
            set: function (value) {
                if (value && !this.$store.state.dicom.isMiddleQuality) {
                    this.$store.commit(mutationTypes.isLowQualityChange, false);
                    this.$store.commit(mutationTypes.isMiddleQualityChange, true);
                    this.$store.commit(mutationTypes.isHighQualityChange, false);
                    updateDicomZipUrl();
                }
            }
        },
        isHighQuality: {
            get: function () {
                return this.$store.state.dicom.isHighQuality;
            },
            set: function (value) {
                if (value && !this.$store.state.dicom.isHighQuality) {
                    this.$store.commit(mutationTypes.isLowQualityChange, false);
                    this.$store.commit(mutationTypes.isMiddleQualityChange, false);
                    this.$store.commit(mutationTypes.isHighQualityChange, true);
                    updateDicomZipUrl();
                }
            }
        },
    },
    methods: {
        dicomLowClick: function (event) {
            console.log("dicomLowClick");
            this.isLowQuality = true;
        },
        dicomMiddleClick: function (event) {
            console.log("dicomMiddleClick");
            this.isMiddleQuality = true;
        },
        dicomHighClick: function (event) {
            console.log("dicomHighClick");
            this.isHighQuality = true;
        }
    }
}

</script>

<style scoped>
.border-bottom-item {
    margin-bottom: 0;
}

.flex-menu-item {
    width: 85px;
    /* display: flex; */
    /* align-items: flex-end; */
    /* justify-content: center; */
}

.flex-separator {
    flex-grow: 1;
}
</style>